<template>
    <div class="too-much-search" data-testid="too-much-search">
        <h2 class="too-much-search__title">
            {{ $t('search.too.many.requests.title') }}
        </h2>

        <p class="too-much-search__advice-title">
            {{ $t('search.too.many.requests.advice') }}
        </p>
    </div>
</template>
<style scoped lang="scss">
    .too-much-search {
        display: grid;

        &__title {
            padding: var(--joy-core-spacing-6) 0 0 var(--joy-core-spacing-12);
        }

        &__advice-title {
            padding: 0 0 0 var(--joy-core-spacing-12);
        }
    }
</style>
